var origin = 'https://slack.com'

// allow configuring the url if steno is running on a non-standard port/host
if (process.env.STENO_URL) {
  origin = process.env.STENO_URL
}

module.exports = origin



//////////////////
// WEBPACK FOOTER
// ./node_modules/slack/src/_origin.js
// module id = 111
// module chunks = 1